import { render } from "./StepsWrapper.vue?vue&type=template&id=56b61633"
import script from "./StepsWrapper.vue?vue&type=script&lang=js"
export * from "./StepsWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__